import { ReactNode } from 'react';

export interface StatusTagProps {
  className?: string;
  status: ExportStatus | string;
  label: ReactNode | string;
  variant?: 'filled' | 'outlined';
  colorMap: Record<string, TagColor>;
  key?: React.Key | null | undefined;
  fullWidth?: boolean | undefined;
}

export enum ExportStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS',
  UPLOADING = 'UPLOADING',
  EXPORTING = 'EXPORTING',
}

export type TagColor = 'error' | 'primary' | 'warning' | 'success' | 'default';

export const exportStatusColorMap: Record<string, TagColor> = {
  FAILED: 'error',
  PROCESSING: 'primary',
  PENDING: 'warning',
  UPLOADING: 'success',
  SUCCESS: 'success',
};

export const memberStatusColorMap: Record<string, TagColor> = {
  ACTIVE: 'success',
  PENDING: 'warning',
  DELETED: 'error',
  INACTIVE: 'default',
};

export const userStatusColorMap: Record<string, TagColor> = {
  ACTIVE: 'success',
  PENDING: 'warning',
  REMOVED: 'error',
  DEACTIVATE: 'default',
};
